// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import moment from "moment";
import Calendar from "react-calendar";
import I18n from "../../../i18n/I18n";
import { AsnTable } from "../";
import Helper from "../../../helper/Helper";
import {
  Dropdown,
  Button,
  Icon,
  Modal,
  LocaleLink,
  Loader
} from "../../common";
import styles from "./PreviewItems.scss";

class PreviewItems extends Component {
  state = {
    warehouse_from: "",
    warehouse_to: "",
    id_fbn_slot: "",
    modalOpen: false,
    importError: "",
    importSuccess: "",
    date:
      this.props.asnInfo && this.props.asnInfo.scheduled_at
        ? new Date(this.props.asnInfo && this.props.asnInfo.scheduled_at)
        : new Date(moment()),
    modalOpen: false
  };

  componentDidMount = () => {
    if (this.state.date) {
      const obj = {
        scheduled_at: this.state.date,
        id_fbn_asn: this.props.fbnAsn
      };
      this.props.retrieveSlots(obj);
    }
  };

  openModal = () => {
    this.setState({
      modalOpen: true
    });
  };

  onCloseModal = () => {
    this.setState({
      modalOpen: false
    });
  };

  onChange = date => {
    this.setState({ date });
    if (date) {
      const obj = {
        scheduled_at: moment(date).format("YYYY-MM-DD"),
        id_fbn_asn: this.props.fbnAsn
      };
      this.props.retrieveSlots(obj);
    }
  };

  selectSlot = id_fbn_slot => {
    this.setState({
      id_fbn_slot
    });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  onCloseModal = () => {
    this.setState({
      modalOpen: false,
      importError: "",
      importSuccess: ""
    });
  };

  formatDate = (val, format) => {
    return moment(val).format(format);
  };

  onConfirm = () => {
    if (this.props.fbnAsn && this.state.date && this.props.currentBatch) {
      const obj = {
        id_fbn_asn: this.props.fbnAsn,
        scheduled_at: moment(this.state.date).format("YYYY-MM-DD"),
        id_fbn_asn_batch: this.props.currentBatch
      };
      if (this.state.id_fbn_slot) {
        obj.id_fbn_slot = this.state.id_fbn_slot;
      } else if (this.props.asnInfo && this.props.asnInfo.id_fbn_slot) {
        obj.id_fbn_slot = this.props.asnInfo.id_fbn_slot;
      }

      if (obj.id_fbn_slot) {
        this.props.scheduleAsn(obj);
        this.onCloseModal();
      }
    }
  };

  render() {
    const {
      isImportLoading,
      isScheduleLoading,
      lines,
      history,
      view,
      seller,
      browser,
      scheduleAsn,
      loadFunc,
      timeslots,
      type,
      isImporting,
      openModal,
      batches,
      toggleBatch,
      currentBatch,
      asnInfo,
      scrollPage,
      noOfPages,
      isInitialLoading,
      retrieveSlots,
      slots,
      isGettingSlots,
      barcodeRecvMethod
    } = this.props;

    const match =
      batches &&
      batches.find(batch => batch && batch.id_fbn_asn_batch === currentBatch);

    const slotComp =
      slots && slots.slots && !_.isEmpty(slots.slots)
        ? slots.slots.map((slot, index) => (
            <div>
              <Button
                className={styles.slotBtn}
                variant={
                  slot.id_fbn_slot === this.state.id_fbn_slot
                    ? "asn"
                    : "transparent"
                }
                onClick={() => this.selectSlot(slot.id_fbn_slot)}
              >
                {slot.name}
              </Button>
            </div>
          ))
        : "";

    const minimumDate = new Date(moment());
    return (
      <div className={styles.itemsCtr}>
        <div className={styles.lineCtr}>
          {lines && !_.isEmpty(lines) ? (
            <AsnTable
              barcodeRecvMethod={barcodeRecvMethod}
              data={lines}
              view={"grid"}
              browser={browser}
              lang={Helper.getLocale()}
              scroll
              eligbleEnabled
              loadFunc={loadFunc}
              lineType={asnInfo && asnInfo.status === "cancelled" ? 2 : type}
              scrollLoading={scrollPage && noOfPages && scrollPage < noOfPages}
            />
          ) : (
            <div className={styles.blankBtn}>
              {isInitialLoading ? (
                <Loader style={{ height: "unset" }} />
              ) : (
                <div>
                  <div className={styles.importTxt}>
                    {I18n.getText(
                      type === 1
                        ? "transfers.import-fbn-transfers"
                        : "transfers.nothing-to-show"
                    )}
                  </div>
                  {type === 1 ? (
                    <Button
                      className={styles.printCtr}
                      onClick={() => openModal()}
                      disabled={asnInfo && asnInfo.status === "cancelled"}
                    >
                      <Icon name="stack" className={styles.printIcon} />
                      {isImporting ? (
                        <div className={styles.loader} />
                      ) : (
                        I18n.getText("transfers.import-offers")
                      )}
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        {type === 1 &&
        lines &&
        !_.isEmpty(lines) &&
        asnInfo &&
        asnInfo.status !== "cancelled" ? (
          <div className={styles.footerBtnCtr}>
            <Button
              variant="transparent"
              onClick={() => this.goBack()}
              className={styles.printCtr}
            >
              {I18n.getText("transfers.cancel")}
            </Button>
            <Button
              className={styles.printCtr}
              onClick={
                asnInfo && asnInfo.scheduled_at
                  ? () => this.onConfirm()
                  : () => this.openModal()
              }
              disabled={
                (asnInfo && asnInfo.status === "cancelled") ||
                (match && !_.isEmpty(match) && match.is_scheduled)
              }
            >
              {isScheduleLoading ? (
                <div className={styles.loader} />
              ) : (
                I18n.getText(
                  asnInfo && asnInfo.scheduled_at
                    ? "transfers.update-asn"
                    : "transfers.schedule-asn"
                )
              )}
            </Button>
          </div>
        ) : (
          ""
        )}
        <Modal
          contentLabel={"schedule"}
          isOpen={this.state.modalOpen}
          submitDisabled={!slots}
          closeModal={() => this.onCloseModal()}
          onSubmit={() => this.onConfirm()}
          cancelBtnLabel={I18n.getText("product.cancel-btn")}
          submitBtnLabel={I18n.getText("product.confirm-btn")}
          dialogBox
          dialogTitle={I18n.getText("transfers.schedule-date")}
        >
          <div className={styles.modalCtr}>
            <h3 className={styles.modalSub}>
              {I18n.getText("transfers.select-schedule-title")}
            </h3>
            <Calendar
              className={styles.calendar}
              tileClassName={styles.tile}
              formatShortWeekday={value => this.formatDate(value, "dd")}
              onChange={this.onChange}
              value={this.state.date}
              activeStartDate={minimumDate}
              minDate={minimumDate}
            />
            <div className={styles.attrCtr}>
              <p>{I18n.getText("transfers.scheduled-date")}</p>
              <div className={styles.attrVal}>
                {this.state.date
                  ? moment(this.state.date).format("YYYY-MM-DD")
                  : ""}
              </div>
            </div>
            {slots && slots.slots ? (
              <div className={styles.attrCtr}>
                <p>{I18n.getText("transfers.select-time-slot")}</p>
                {slotComp}
              </div>
            ) : (
              ""
            )}
          </div>
        </Modal>
      </div>
    );
  }
}
export default PreviewItems;



// WEBPACK FOOTER //
// ./src/components/transfers/previewItems/PreviewItems.js